import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from '@nuxt/ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _38e88f2f = () => interopDefault(import('../pages/compliance-report/index.vue' /* webpackChunkName: "pages/compliance-report/index" */))
const _53e980e3 = () => interopDefault(import('../pages/qir/index.vue' /* webpackChunkName: "pages/qir/index" */))
const _13debcce = () => interopDefault(import('../pages/compliance-report/thank-you.vue' /* webpackChunkName: "pages/compliance-report/thank-you" */))
const _41cccd66 = () => interopDefault(import('../pages/qir/thank-you.vue' /* webpackChunkName: "pages/qir/thank-you" */))
const _2dfb1658 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/compliance-report/",
    component: _38e88f2f,
    pathToRegexpOptions: {"strict":true},
    name: "compliance-report"
  }, {
    path: "/qir/",
    component: _53e980e3,
    pathToRegexpOptions: {"strict":true},
    name: "qir"
  }, {
    path: "/compliance-report/thank-you/",
    component: _13debcce,
    pathToRegexpOptions: {"strict":true},
    name: "compliance-report-thank-you"
  }, {
    path: "/qir/thank-you/",
    component: _41cccd66,
    pathToRegexpOptions: {"strict":true},
    name: "qir-thank-you"
  }, {
    path: "/",
    component: _2dfb1658,
    pathToRegexpOptions: {"strict":true},
    name: "index"
  }],

  fallback: false
}

function decodeObj(obj) {
  for (const key in obj) {
    if (typeof obj[key] === 'string') {
      obj[key] = decode(obj[key])
    }
  }
}

export function createRouter () {
  const router = new Router(routerOptions)

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    const r = resolve(to, current, append)
    if (r && r.resolved && r.resolved.query) {
      decodeObj(r.resolved.query)
    }
    return r
  }

  return router
}
